export default "__VITE_ASSET__BqEz42xF__"